module.exports = __webpack_public_path__ + "static/img/stay-option-icon-kitchen.937eba68.svg";